export const setLottieOptions = (lottie) => ({
  loop: true,
  autoplay: true,
  animationData: lottie,
  rendererSettings: {
    preserveAspectRatio: 'xMidYMid slice',
  },
});
